import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { Observer } from 'gsap/Observer'

gsap.registerPlugin(Observer)

export default class extends BaseModule {
  init() {
    this.openState = false
    this.currentIndex = false
    this.isTransiting = false

    this.btn = this.el.querySelector('[data-navigation="btn"]')
    this.btn.addEventListener('click', () => {
      this.toggleMenu()
    })

    document.addEventListener('page:change', () => {
      this.closeMenu()
    })

    const langLinks = this.el.querySelectorAll('[data-navigation-submenu] a')
    langLinks[0].addEventListener('click', (e) => {
      e.preventDefault()
    })
  }

  toggleMenu() {
    if (this.openState) {
      window.lenis.start()
      this.closeMenu()
    } else {
      window.lenis.stop()
      this.openMenu()
    }
  }

  async closeMenu() {
    if (!this.openState) return

    document.body.classList.remove('has-menu-opened')
    this.openState = false
    this.btn.setAttribute('aria-expanded', false)
  }

  async openMenu() {
    if (this.openState) return

    document.body.classList.add('has-menu-opened')
    this.openState = true
    this.btn.setAttribute('aria-expanded', true)
  }
}
